import { jsx } from 'react/jsx-runtime';

const SvgArrowSmallLeft = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "m9.3 12 5.88-7h-2.62L6.7 12l5.86 7h2.62L9.3 12Z" }) }));

export { SvgArrowSmallLeft as default };
//# sourceMappingURL=ArrowSmallLeft.es.js.map
